<template>
  <div class="mainContent helpContent">
    <pageHead device="desktop" page="maintain" :title="$t('store.uphold_time')"/>
    <div class="rule container mtime">
      <h1 class="title">{{ $t("store.uphold_time") }}</h1>
      <div class="rule-cont rule-maintain" v-for="item in $t('store.maintain_list')">
        <span class="title">{{ item.title }}</span>
        <q>{{ item.date }}</q>
        <p>{{ item.time }}</p>
      </div>
    </div>
  </div>
</template>
<script>
  import pageHead from "~/components/common/pageHead.vue";
  export default {
    components: { pageHead }
  };
</script>
